import React from 'react'
import { Link } from 'gatsby'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import { getCover, getQuality } from '@helpers/helper.rendering'
import { getLocation, getName, getStatus, is_Sold } from '@helpers/helper.developments'
import { useInView } from 'react-intersection-observer'
import Loader from '@components/loader/1'
interface Props {
  isDemo: false
  development: Development
  inMap: boolean
  unities: Property[]
  skeleton?: boolean
}

const MOCK_DEV: Development = {
  id: 2,
  photos: [
    {
      image:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/realistic-3D-rendering-how-it-help-architects-with-renovation-four-whi_eiLRfsR.webp',
      original:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/realistic-3D-rendering-how-it-help-architects-with-renovation-four-whi_eiLRfsR.webp',
      order: 0,
      is_front_cover: true,
      description: '',
      thumb: '',
      is_blueprint: false,
    },
    {
      image:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/56674697627188283287307483173880409537814488047686530895043335269312623924389.webp',
      original:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/56674697627188283287307483173880409537814488047686530895043335269312623924389.webp',
      order: 1,
      description: '',
      is_front_cover: false,
      thumb: '',
      is_blueprint: false,
    },
    {
      image:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/cs04-planos-casa-unifamiliar-autocad-dwg_orig.jpeg',
      original:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/cs04-planos-casa-unifamiliar-autocad-dwg_orig.jpeg',
      order: 0,
      is_blueprint: true,
      description: '',
      is_front_cover: false,
      thumb: '',
    },
    {
      image:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/d51cd7406eb50059a36c1bc1e1a02692.jpeg',
      original:
        'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/d51cd7406eb50059a36c1bc1e1a02692.jpeg',
      order: 1,
      is_blueprint: true,
      description: '',
      is_front_cover: false,
      thumb: '',
    },
  ],
  files: [
    {
      file: 'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/MediaSite_-_Delegacion_de_DNS_.pdf',
      public_name: 'Prueba Archivos',
    },
    {
      file: 'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/comparacion_propiedades_7.pdf',
      public_name: 'Comparable propiedades',
    },
    {
      file: 'https://storage.googleapis.com/mediacore_default_storage_bucket-staging/site/development/comparacion_propiedades_8.pdf',
      public_name: 'Comparable propiedades',
    },
  ],
  construction_status: 3,
  description: '<p>dsfdsf</p>',
  address: 'Avenida Santa Fe 1000',
  geo_lat: '-34.5955437',
  geo_long: '-58.3811806',
  videos: [],
  location: {
    id: 0,
    parent_division: '',
    short_location: '',
    weight: 0,
    state: 'CABA',
    city: 'Comuna 1 / Buenos Aires',
    name: 'Retiro',
    full_location: 'Argentina | CABA | Comuna 1 / Buenos Aires | Retiro',
  },
  custom_tags: [
    // {
    // name: '100vendido',
    // group_name: '',
    // id: 0,
    // public_name: ''
    // }
  ],
  is_starred_on_web: false,
  fake_address: 'Avenida Santa Fe 1000',
  tags: [],
  type: {
    id: 0,
    code: '',
    name: 'Edificio residencial',
  },
  construction_date: '2023-08-16T05:46:00Z',
  publication_title: '',
  branch: undefined,
  display_on_web: false,
  excel_extra_headers: undefined,
  financing_details: '',
  name: 'Bartolo Tower',
  reference_code: '',
  resource_uri: '',
  users_in_charge: undefined,
  web_url: '',
}

const developmentCard3 = (props: Props & RealEstateDataPageComponentData) => {
  const { development, isDemo, skeleton, global_data, inMap } = props
  const { divisionPath, content } = global_data
  const {
    cardsDevelopments: {
      data: { paragraphColor, paragraphHexa, alignCenter },
    },
  } = content
  const data = isDemo ? MOCK_DEV : development
  const { ref, inView } = useInView({
    triggerOnce: true,
  })

  const { button } = global_data.content.cardsDevelopments.data

  const makeUrlUnities = (unities: Property[]) => {
    let url = ''
    unities.forEach((unity, index) => {
      url += `${unity.id}`
      if (index !== unities.length - 1) {
        url += `-`
      }
    })
    return url
  }

  if (skeleton || !inView) {
    return (
      <div
        ref={ref}
        className="dev a card dev-card skeleton"
      >
        {(skeleton || !inView) && <Loader />}
      </div>
    )
  }

  const cardContent = (
    <div
      ref={ref}
      className={
        'card card-development' +
        (!is_Sold(data!) ? ' cursor-pointer' : '') +
        (alignCenter ? ' center-card' : '')
      }
    >
      {is_Sold(data!) ? (
        <div className="development-end-tag text-uppercase">100% VENDIDO</div>
      ) : null}
      <img
        src={getQuality(getCover(data.photos))}
        alt="Portada de imagen emprendimiento"
        className={'object-cover object-center' + (!is_Sold(data!) ? ' cursor-pointer' : '')}
      />
      {inMap && (
        <div
          data-bs-dismiss="modal"
          className="close-card"
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            zIndex: 100,
          }}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
          }}
        >
          <i
            className="icon-close-light"
            style={{
              color: '#FFF',
            }}
          ></i>
        </div>
      )}
      <div className="content text-start">
        <div
          className={'badge ps-0 text-uppercase ' + paragraphColor}
          style={{ color: paragraphHexa }}
        >
          {data && getStatus(data)}
        </div>
        <h4 className="card-title mt-1 mb-2">{data && getName(data)}</h4>
        <p className="text-white d-inline-block card-title-direction ms-0 text-start mb-2 mt-0">
          {data && getLocation(data, true)[0]}
        </p>
        {!is_Sold(data!) ? (
          <div className="onHover d-flex align-items-center justify-content-between">
            <div className="btn btn-outline mt-auto">
              <span className="d-block d-lg-inline">{button?.value || 'Más información'}</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )

  const makeUrl = () => {
    return (
      (divisionPath ?? '') +
      '/emprendimiento/' +
      data?.name
        ?.replaceAll(' ', '-')
        ?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') +
      '/' +
      data?.id
    )
  }

  return inMap ? (
    <a
      href={makeUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {cardContent}
    </a>
  ) : (
    <Link to={makeUrl()}> {cardContent}</Link>
  )
}

export default developmentCard3
